var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUniIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.7,1.792C8.573,1.736 8.427,1.736 8.3,1.792L0.3,5.292C0.118,5.372 0,5.551 0,5.75C0,5.949 0.118,6.128 0.3,6.208L1.167,6.587L1.167,8.233C0.784,8.373 0.5,8.751 0.5,9.213C0.5,9.788 0.944,10.25 1.5,10.25C2.043,10.25 2.5,9.788 2.5,9.213C2.488,8.723 2.167,8.317 1.747,8.205L1.747,6.841L2.96,7.372L2.959,10.536L2.959,14.184C2.959,14.776 3.4,15.25 3.951,15.25L12.468,15.25L12.468,14.285L4.111,14.285C4.035,14.285 3.968,14.226 3.96,14.15L3.959,11.797L3.961,11.797L3.961,10.688C3.961,10.613 4.016,10.545 4.086,10.536L12.707,10.536C12.783,10.536 12.851,10.595 12.859,10.672L12.86,10.689L12.86,14.014L13.86,14.014L13.86,7.451L16.7,6.208C16.882,6.128 17,5.949 17,5.75C17,5.551 16.882,5.372 16.7,5.292L8.7,1.792ZM12.86,7.888L9.013,9.571L12.859,9.571L12.86,7.888ZM3.96,9.572L3.96,7.81L7.987,9.571L3.964,9.571L3.96,9.572ZM8.5,8.704L1.747,5.75L8.5,2.796L15.253,5.75L8.5,8.704Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.832,13.109C6.211,13.109 6.519,12.798 6.519,12.415C6.519,12.032 6.211,11.721 5.832,11.721C5.453,11.721 5.145,12.032 5.145,12.415C5.145,12.798 5.453,13.109 5.832,13.109Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.042,13.109C11.421,13.109 11.729,12.798 11.729,12.415C11.729,12.032 11.421,11.721 11.042,11.721C10.663,11.721 10.355,12.032 10.355,12.415C10.355,12.798 10.663,13.109 11.042,13.109Z",
    style: {
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniIcon);
export default __webpack_public_path__ + "static/media/uniIcon.e0af08c5bdb08e2456f3f195fe8278ae.svg";
export { ForwardRef as ReactComponent };